









































import { Component, Prop, Vue } from 'vue-property-decorator';
import type { Campaign } from '@/core/campaign/models/Campaign';

@Component({
  name: 'ConfirmCampaignMergeDialog',
})
export default class ConfirmCampaignMergeDialog extends Vue {
  @Prop({ required: true }) showDialog!: boolean;
  @Prop({ required: true }) sourceCampaign!: Campaign;
  @Prop({ required: true }) destinationCampaign!: Campaign;

  closeDialog() {
    this.$emit('close');
  }

  confirm() {
    this.$emit('confirm');
  }
}
